import './filters.scss';

interface StateSelectorScope extends ng.IScope {
    opts: string[];
    selected: string[];
}

export class StateSelector implements ng.IComponentController {

    static instance = {
        controller: ['$scope', StateSelector],
        template: require('./state-selector.html'),
        bindings: {
            options: '<',
            placeholder: '@',
            onValueChange: '&'
        }
    };

    private placeholder: string;
    private $scope: StateSelectorScope;
    private options: string[];
    private onValueChange?: (args: { $value: string[] }) => void;

    constructor($scope: StateSelectorScope) {
        this.$scope = $scope;
    }

    $onInit = () => {
        this.$scope.opts = this.options || [];
        this.$scope.opts = this.options || [];
        this.$scope.$watch('selected',
            v => this.onValueChange({ $value: v as string[] })
        );
    };

    $onChanges = (changes) => {
        if (changes.options && changes.options.currentValue) {
            this.$scope.opts = changes.options.currentValue;
        }
    };

    displaySelected = (arr?: string[]): string => {
        if (!arr || !arr.length) { return this.placeholder; }
        const limit = 3;
        const shown = arr.slice(0, limit).join(', ');

        return arr.length > limit
            ? `${shown} … (${arr.length})`
            : shown;
    };
}
